export default "__VITE_ASSET__Bi1su2h4__"